/** Default IANA timezone (OMIND HQ / company base). */
export const DEFAULT_USER_TIMEZONE = 'Europe/Berlin';

/**
 * Browser IANA timezone, or DEFAULT_USER_TIMEZONE if unavailable / unknown.
 */
export function getBrowserTimezone() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && typeof tz === 'string' && tz.trim()) {
      return tz.trim();
    }
  } catch {
    /* ignore */
  }
  return DEFAULT_USER_TIMEZONE;
}

/**
 * Sorted IANA timezone list for Select options.
 * Prefer Intl.supportedValuesOf; always include DEFAULT_USER_TIMEZONE.
 */
export function getTimezoneOptions() {
  let zones = [];
  try {
    if (typeof Intl.supportedValuesOf === 'function') {
      zones = Intl.supportedValuesOf('timeZone');
    }
  } catch {
    zones = [];
  }
  if (!Array.isArray(zones) || zones.length === 0) {
    zones = [
      'Europe/Berlin',
      'Europe/London',
      'Europe/Paris',
      'America/New_York',
      'America/Chicago',
      'America/Los_Angeles',
      'Asia/Tokyo',
      'Asia/Shanghai',
      'Australia/Sydney',
      'UTC',
    ];
  }
  const set = new Set(zones);
  set.add(DEFAULT_USER_TIMEZONE);
  return Array.from(set).sort((a, b) => a.localeCompare(b));
}

/**
 * Prefer stored user timezone; else browser; else Berlin.
 */
export function resolveTimezoneForForm(stored) {
  if (typeof stored === 'string' && stored.trim()) {
    return stored.trim();
  }
  return getBrowserTimezone();
}
